import BinList from './component';

export default BinList;
